export default [
    {
        path: 'ria-relatorio-envio',
        component: () => import(
            /* webpackChunkName: 'integracao-ria-relatorio-envio' */
            '@/views/integracao/ria/relatorio-envio/Index'
        ),
        redirect: 'ria-relatorio-envio/index',
        children: [
            {
                name: 'integracao-ria-relatorio-envio-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'integracao-ria-relatorio-envio' */
                    '@/views/integracao/ria/relatorio-envio/List.vue'
                ),
            },
        ],
    },
]